import USER_ROLES from '../../../../constants/userRoles.constants';

class StepPublishController {
    /**
     * @param {Object} evaluationService
     * @param {$stateParams} $stateParams
     * @param {$state} $state
     * @param {$mdDialog} $mdDialog
     * @param {$filter} $filter
     * @param {$rootScope} $rootScope
     * @param {$timeout} $timeout
     * @param {Object} pedagogicalService
     * @param {Object} RulerService
     */
    constructor(
        evaluationService,
        $stateParams,
        $state,
        $mdDialog,
        $filter,
        $rootScope,
        $timeout,
        pedagogicalService,
        userService,
        rulerService,
        $scope,
    ) {
        this.evaluationService = evaluationService;
        this.$mdDialog = $mdDialog;
        this.$scope = $scope;
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.rulerService = rulerService;
        this.pedagogicalService = pedagogicalService;
        this.userService = userService;
        this.newImage = {};
        this.uploadError = {};
        this.evaluationId = $stateParams.id;
        this.flags = [
            {
                name: 'certified',
                title: 'The product is certified?',
            },
        ];

        if (this.userService.isInRole(USER_ROLES.ROLE_ADMIN)) {
            this.$timeout(() => {
                this.evaluationService
                    .getEvaluationData(this.evaluationId)
                    .then((dataDirty) => {
                        this.evaluationData = dataDirty;
                        this.evaluationData.updatedAt = new Date(
                            this.evaluationData.updatedAt,
                        );
                        this.flags.forEach((entry) => {
                            entry.value = dataDirty.publishFlags[entry.name];
                        });

                        this.publishFlag = {
                            name: 'publishDate',
                            value: dataDirty.publishFlags.publishDate,
                        };
                        this.unpublishPalogga = {
                            name: 'unpublishPalogga',
                            value: dataDirty.publishFlags.publishDatePalogga === null,
                        };
                        this.publishFlagPalogga = {
                            name: 'publishDatePalogga',
                            value: dataDirty.publishFlags.publishDatePalogga,
                        };
                        this.publishDate = dataDirty.publishFlags.publishDate ?
                            new Date(dataDirty.publishFlags.publishDate) :
                            this.publishDate;

                        this.publishDatePalogga = dataDirty.publishFlags.publishDatePalogga ?
                            new Date(dataDirty.publishFlags.publishDatePalogga) :
                            this.publishDatePalogga;
                        this.drawScoreRuler();
                    });
            }, 1000);
        } else {
            this.$state.go('home');
        }
    }

    $onDestroy() {
        this.$scope.$on('$stateChangeStart', () => {
            this.saveImages();
            this.saveJustifications();
        });
    }

    checkIndicators() {
        return this.flags.every(entry => entry.value === true);
    }

    saveJustifications(showSuccess = true) {
        const sliders = this.evaluationData.publishSliders;
        const passive = sliders.find(e => e.left === 'Passive');
        const rehearse = sliders.find(e => e.left === 'Rehearse');
        const nonLinear = sliders.find(e => e.left === 'Linear');
        const individual = sliders.find(e => e.left === 'Individual');
        const data = {
            PAJustification: passive ? passive.justification : '',
            RCJustification: rehearse ? rehearse.justification : '',
            NLJustification: nonLinear ? nonLinear.justification : '',
            ICJustification: individual ? individual.justification : '',
        };

        this.evaluationService.saveJustifications(
            data,
            this.evaluationId,
            showSuccess,
        );
    }

    saveImages() {
        if (
            this.evaluationData.publishImages.items &&
            this.evaluationData.publishImages.items.length === 0
        ) {
            return;
        }
        this.evaluationService.saveImages(
            this.evaluationData.publishImages,
            this.evaluationId,
        );
    }

    savePage() {
        this.saveJustifications(false);
        this.saveImages();
    }

    uploadImage() {
        this.uploadError.publishImages = null;
        if (this.newImage && this.newImage.size > 3000000) {
            this.uploadError.publishImages = 'TOO_LARGE';
            return;
        }
        this.evaluationService.uploadPublishImage(this.newImage).then((e) => {
            this.evaluationData.publishImages.items.push({
                link: e.data.path,
                subtitle: '',
                published: true,
            });
        });
    }

    changeFlag(flags, currentFlag) {
        this.flagToSend = this.prepareFlagsToSend(
            flags,
            this.publishFlag.value,
        );
        this.evaluationService
            .changePublishFlag(this.evaluationId, this.flagToSend, false)
            .then((data) => {
                if (!data) {
                    this.$mdDialog.show(
                        this.$mdDialog
                            .alert()
                            .title('Could not publish evaluation')
                            .textContent('Some required data might be missing')
                            .ok('OK'),
                    );
                } else {
                    this.$rootScope.evaluationStatusRootScope =
                        data.status.replace('_', ' ');
                }
            })
            .catch(() => (currentFlag.value = !currentFlag.value));
    }

    prepareFlagsToSend(flags, newDate, publishPalogga = false, unpublishPalogga = false, publishKokoa = false) {
        const flagToSend = {};
        Object.keys(flags).forEach((key) => {
            const val = flags[key];
            const flagAttr = val.name;
            flagToSend[flagAttr] = val.value;
        });

        if (unpublishPalogga) {
            flagToSend.unpublishPalogga = true;
        }

        if (publishPalogga) {
            flagToSend.publishDatePalogga = newDate ? new Date(newDate) : new Date();
        }

        if (publishKokoa) {
            flagToSend.publishDate = newDate ? new Date(newDate) : new Date();
        }
        return flagToSend;
    }

    showSetPublishDateDialog(publishDate) {
        this.$mdDialog
            .show({
                clickOutsideToClose: true,
                templateUrl: 'setPublishDateDialog.tmpl.html',
                parent: angular.element(document.body),
                multiple: true,
                controller: function DialogController($scope, $mdDialog) {
                    $scope.minDate = new Date();
                    $scope.minDate.setDate($scope.minDate.getDate() + 1);
                    $scope.closeDialog = () => {
                        $mdDialog.cancel();
                    };
                    $scope.save = (result) => {
                        $mdDialog.hide(result);
                    };
                    $scope.publishDate = publishDate;
                },
            })
            .then((result) => {
                const flagToSend = this.prepareFlagsToSend(this.flags, result);
                this.evaluationService
                    .changePublishFlag(this.evaluationId, flagToSend, false)
                    .then(
                        (data) => {
                            this.$rootScope.evaluationStatusRootScope =
                                data.status.replace('_', ' ');
                            this.publishDate = data.publishFlags.publishDate;
                            this.evaluationData.updatedAt = new Date(
                                data.updatedAt,
                            );
                        },
                        (err) => {
                            this.$mdDialog.show(
                                this.$mdDialog
                                    .alert()
                                    .title('Could not publish evaluation')
                                    .textContent(err.data)
                                    .ok('OK'),
                            );
                        },
                    );
            });
    }

    showSetPublishDatePaloggaDialog(publishDate) {
        this.$mdDialog
            .show({
                clickOutsideToClose: true,
                templateUrl: 'setPublishDateDialog.tmpl.html',
                parent: angular.element(document.body),
                multiple: true,
                controller: function DialogController($scope, $mdDialog) {
                    $scope.minDate = new Date();
                    $scope.minDate.setDate($scope.minDate.getDate() + 1);
                    $scope.closeDialog = () => {
                        $mdDialog.cancel();
                    };
                    $scope.save = (result) => {
                        $mdDialog.hide(result);
                    };
                    $scope.publishDatePalogga = publishDate;
                },
            })
            .then((result) => {
                const flagToSend = this.prepareFlagsToSend(this.flags, result, true);
                this.evaluationService
                    .changePublishFlag(this.evaluationId, flagToSend, false)
                    .then(
                        (data) => {
                            this.$rootScope.evaluationStatusRootScope =
                                data.status.replace('_', ' ');
                            this.publishDatePalogga = data.publishFlags.publishDatePalogga;
                            this.evaluationData.updatedAt = new Date(
                                data.updatedAt,
                            );
                        },
                        (err) => {
                            this.$mdDialog.show(
                                this.$mdDialog
                                    .alert()
                                    .title('Could not publish evaluation')
                                    .textContent(err.data)
                                    .ok('OK'),
                            );
                        },
                    );
            });
    }

    publishNow() {
        const flagToSend = this.prepareFlagsToSend(this.flags, false, false,false ,true);
        this.$mdDialog
            .show(
                this.$mdDialog.confirm({
                    title: 'Are you sure?',
                    textContent:
                        'This action will make the evaluation available on website.',
                    cancel: 'Cancel',
                    ok: 'Yes, I want to proceed',
                    clickOutsideToClose: true,
                }),
            )
            .then(
                () => {
                    this.evaluationService
                        .changePublishFlag(this.evaluationId, flagToSend, true)
                        .then(
                            (data) => {
                                this.$rootScope.evaluationStatusRootScope =
                                    data.status.replace('_', ' ');
                                this.publishDate =
                                    data.publishFlags.publishDate;
                                this.publishDatePalogga =
                                    data.publishFlags.publishDatePalogga;
                                this.$mdDialog.show(
                                    this.$mdDialog
                                        .alert()
                                        .title(
                                            'The evaluation has been successfully sent to Kokoa.io! ',
                                        )
                                        .textContent(
                                            // eslint-disable-next-line max-len
                                            'For being available at Kokoa.io, the evaluation needs to be checked and approved by the Kokoa.io admins',
                                        )
                                        .ok('OK'),
                                );
                            },
                            (err) => {
                                this.$mdDialog.show(
                                    this.$mdDialog
                                        .alert()
                                        .title('Could not publish evaluation')
                                        .textContent(err.data)
                                        .ok('OK'),
                                );
                            },
                        );
                },
                () => false,
            );
    }

    publishNowPalogga() {
        const flagToSend = this.prepareFlagsToSend(this.flags, false, true);
        this.$mdDialog
            .show(
                this.$mdDialog.confirm({
                    title: 'Are you sure?',
                    textContent:
                        'This action will make the evaluation available on website.',
                    cancel: 'Cancel',
                    ok: 'Yes, I want to proceed',
                    clickOutsideToClose: true,
                }),
            )
            .then(
                () => {
                    this.evaluationService.changePublishFlag(this.evaluationId, flagToSend, true)
                        .then(
                            (data) => {
                                this.$rootScope.evaluationStatusRootScope =
                                    data.status.replace('_', ' ');
                                this.publishDate =
                                    data.publishFlags.publishDate;
                                this.publishDatePalogga =
                                    data.publishFlags.publishDatePalogga;
                                this.$mdDialog.show(
                                    this.$mdDialog
                                        .alert()
                                        .title(
                                            'The evaluation has been publish for Palogga! ',
                                        )
                                        .textContent(
                                            // eslint-disable-next-line max-len
                                            'For being available at Palloga, the evaluation needs to be checked and approved by the Kokoa.io admins',
                                        )
                                        .ok('OK'),
                                );
                            },
                            (err) => {
                                this.$mdDialog.show(
                                    this.$mdDialog
                                        .alert()
                                        .title('Could not publish evaluation')
                                        .textContent(err.data)
                                        .ok('OK'),
                                );
                            },
                        );
                },
                () => false,
            );
    }

    unpublishNowPalogga() {
        const flagToSend = this.prepareFlagsToSend(this.flags, false, false, true);
        this.$mdDialog
            .show(
                this.$mdDialog.confirm({
                    title: 'Are you sure?',
                    textContent:
                        'This action will unpublish evaluation from Palogga catalog.',
                    cancel: 'Cancel',
                    ok: 'Yes, I want to proceed',
                    clickOutsideToClose: true,
                }),
            )
            .then(
                () => {
                    this.evaluationService
                        .changePublishFlag(this.evaluationId, flagToSend, false)
                        .then(
                            (data) => {
                                this.$rootScope.evaluationStatusRootScope =
                                    data.status.replace('_', ' ');
                                this.publishDatePalogga =
                                    data.publishFlags.publishDatePalogga;
                                this.$mdDialog.show(
                                    this.$mdDialog
                                        .alert()
                                        .title(
                                            'The evaluation has been removed from Palogga catalog!',
                                        )
                                        .textContent(
                                            'This evaluation will be not available in Palogga catalog',
                                        )
                                        .ok('OK'),
                                );
                            },
                            (err) => {
                                this.$mdDialog.show(
                                    this.$mdDialog
                                        .alert()
                                        .title('Could unpublish')
                                        .textContent(err.data)
                                        .ok('OK'),
                                );
                            },
                        );
                },
                () => false,
            );
    }

    calculateParamScore(parameters) {
        const paramsMatchScores = [];
        this.hiddenParameters = [];
        Object.keys(parameters).forEach((key) => {
            if (typeof parameters[key] === 'object') {
                if (
                    !(this.hiddenParameters[parameters[key].parameter] === true)
                ) {
                    paramsMatchScores.push(
                        this.rulerService.calcMatchScores(
                            parameters[key].questions,
                        ),
                    );
                }
            }
        });
        return paramsMatchScores;
    }

    drawScoreRuler() {
        this.$timeout(() => {
            const rulerOffset = 20;
            const rulerLength = 210;

            this.evaluationData.publishSliders.forEach((score, i) => {
                const canvas = document.getElementById(`ruler_${i}`);
                if (!canvas) {
                    return;
                }
                const ctx = canvas.getContext('2d');
                ctx.fillStyle = '#d6e0e5';
                ctx.fillRect(rulerOffset, 20, rulerLength, 10);

                ctx.fillRect(rulerOffset, 12, 3, 10);
                ctx.fillRect(rulerOffset + rulerLength - 3, 12, 3, 10);

                ctx.fillStyle = 'black';
                ctx.textAlign = 'center';
                const textStart = '';
                ctx.fillText(textStart, rulerOffset, 10);
                const textEnd = '';
                ctx.fillText(textEnd, rulerLength + rulerOffset, 10);

                const step = rulerLength / (2 * score.range);
                const glassPosition =
                    step * (score.magnifyingGlass + score.range) + rulerOffset;
                ctx.fillStyle = '#000000';
                // ctx.fillText(score.magnifyingGlass, glassPosition, 10);
                ctx.lineWidth = 2;
                ctx.beginPath();
                ctx.arc(glassPosition, 24, 8, 0, 2 * Math.PI);
                ctx.fillStyle = 'rgba(255, 255, 255, 0.5)';
                ctx.fill();
                ctx.strokeStyle = '#003459';
                ctx.stroke();

                // draw Glass line
                ctx.beginPath();
                ctx.moveTo(glassPosition + 5, 29);
                ctx.lineTo(glassPosition + 10, 35);
                ctx.stroke();
            });
        }, 0);
    }

    performExport(event) {
        this.exportInProgress = true;
        this.evaluationService
            .exportEvaluation(this.evaluationId)
            .then((data) => {
                this.$mdDialog
                    .show(
                        this.$mdDialog
                            .confirm()
                            .clickOutsideToClose(true)
                            .title('Export finished successfully')
                            .ok('Open Presentation')
                            .cancel('OK'),
                    )
                    .then(() => {
                        window.open(data.url, '_blank');
                    });
            })
            .catch((err) => {
                this.$mdDialog.show(
                    this.$mdDialog
                        .alert()
                        .clickOutsideToClose(true)
                        .title(err.data)
                        .ok('OK'),
                );
            })
            .then(() => {
                this.exportInProgress = false;
            });
    }
}

StepPublishController.$inject = [
    'EvaluationService',
    '$stateParams',
    '$state',
    '$mdDialog',
    '$filter',
    '$rootScope',
    '$timeout',
    'PedagogicalService',
    'UserService',
    'RulerService',
    '$scope',
];

export default StepPublishController;



// WEBPACK FOOTER //
// ./src/app/pages/evaluation/pages/stepPublish/stepPublishController.js